"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var React = __importStar(require("react"));
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var icons_1 = require("../../../../common/icons");
var store_1 = require("../../../../app/store");
var SleepDataStore_1 = require("../../../../app/store/SleepDataStore");
var styles = function (theme) { return (0, core_1.createStyles)({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    iconButton: {},
    label: {
        margin: theme.spacing(0, 1),
        padding: theme.spacing(0, 4),
        textTransform: 'capitalize',
    },
    description: {
        color: theme.youwell.colors.secondary,
    },
}); };
var useStyles = (0, core_1.makeStyles)(function (theme) { return styles(theme); }, { name: 'WeekSelector' });
var WeekSelector = function (_a) {
    var onChange = _a.onChange;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var selectedWeek = (0, store_1.useYouwellSelector)(function (state) { return state.sleepDataStore.selectedWeek; });
    var setWeek = function (week) {
        dispatch((0, SleepDataStore_1.setSelectedWeek)(week));
        if (onChange) {
            onChange(week);
        }
    };
    var next = function () {
        setWeek((0, dateUtils_1.getWeek)((0, dateUtils_1.addDays)(selectedWeek.start, 7)));
    };
    var prev = function () {
        setWeek((0, dateUtils_1.getWeek)((0, dateUtils_1.addDays)(selectedWeek.start, -7)));
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(core_1.IconButton, { color: "secondary", onClick: prev, className: classes.iconButton },
            React.createElement(icons_1.PrevIcon, null)),
        React.createElement("div", { className: classes.label },
            React.createElement(core_1.Typography, { variant: "h6", color: "primary", align: "center" }, "".concat(translate('time.week'), " ").concat(selectedWeek.weekNo)),
            React.createElement(core_1.Typography, { className: classes.description }, "".concat((0, dateUtils_1.shortDate)(selectedWeek.start), " - ").concat((0, dateUtils_1.shortDate)(selectedWeek.end)))),
        React.createElement(core_1.IconButton, { color: "secondary", onClick: next, className: classes.iconButton },
            React.createElement(icons_1.NextIcon, null))));
};
exports.default = WeekSelector;
